import { useState, useEffect } from 'react';
import { ConsultantApp } from './consultant/ConsultantApp';
import { ClientApp } from './client/ClientApp';
import { Login } from './components/Login';
import { getCurrentUser } from './lib/api/auth';
import { supabase } from './lib/supabase';
import type { User } from './lib/api/auth';

function App() {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  const isConsultantRoute = window.location.pathname.startsWith('/consultant');
  const isClientRoute = window.location.pathname.startsWith('/client');

  useEffect(() => {
    loadUser();

    const { data: authListener } = supabase.auth.onAuthStateChange((event) => {
      (async () => {
        try {
          if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
            const user = await getCurrentUser();
            setCurrentUser(user);
          } else if (event === 'SIGNED_OUT') {
            setCurrentUser(null);
          }
        } catch (error) {
          console.error('Error in auth state change:', error);
        }
      })();
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const loadUser = async () => {
    try {
      const user = await getCurrentUser();
      setCurrentUser(user);
    } catch (error) {
      console.error('Error loading user:', error);
      setCurrentUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">Laden...</div>
      </div>
    );
  }

  if (isClientRoute) {
    return <ClientApp />;
  }

  if (!currentUser) {
    return <Login onLogin={setCurrentUser} />;
  }

  if (isConsultantRoute || currentUser.role === 'consultant' || currentUser.role === 'owner' || currentUser.role === 'designer') {
    return <ConsultantApp user={currentUser} onLogout={() => setCurrentUser(null)} />;
  }

  return <ClientApp />;
}

export default App;
